import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const AdminOnlyRoute = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from('accounts')
        .select('is_admin')
        .eq('id', user.id)
        .single();

      if (error) throw error;
      
      setIsAdmin(data.is_admin || false);
    } catch (error) {
      console.error('Error checking admin status:', error);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand"></div>
    </div>;
  }

  if (!isAdmin) {
    return <Redirect to="/user/dashboard" />;
  }

  return children;
};

export default AdminOnlyRoute;
